import * as React from 'react';
import { Placement } from './placement';
import { useAdSense } from '../hooks/adSense';
import { AdSenseForShopping } from './ad-sense-for-shopping';
import { useDeviceType } from '../hooks/deviceType';

import {
    SearchResultBannersSpacing,
    Props,
} from './search-result-banners-server';

const SearchResultBannersClient: React.FC<Props> = (props) => {
    const {
        cols = 1,
        vertical,
        subvertical,
        deviceType: deviceTypeFromServer,
        searchSummary,
    } = props;

    const deviceType = useDeviceType(deviceTypeFromServer);
    const children = React.Children.toArray(props.children);

    const { showAdSense, showAdSenseBoards } = useAdSense(
        children,
        deviceType,
        vertical,

        searchSummary,
        cols !== 1,
        children.length === 0,
    );

    return (
        <>
            <SearchResultBannersSpacing
                deviceType={deviceType}
                cols={cols}
                vertical={vertical}
                subvertical={subvertical}
                spacer={(id, index) => (
                    <Placement
                        id={id}
                        grid={cols !== 1}
                        vertical={vertical}
                        subvertical={subvertical}
                        key={id}
                        deviceType={deviceType}
                        showBanners={true}
                        type={
                            index !== 1 && showAdSenseBoards
                                ? 'shopping'
                                : 'ast'
                        }
                    />
                )}
            >
                {children}
            </SearchResultBannersSpacing>
            {showAdSense && (
                <AdSenseForShopping
                    id="afshcontainer"
                    deviceType={deviceType}
                />
            )}
        </>
    );
};

export default SearchResultBannersClient;
